import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  statusBadge: {
    margin: '0 1rem',
    padding: '.3rem',
    borderRadius: 'var(--border-radius-lg)',
    backgroundColor: 'var(--color-neutral-700)',
    fontSize: '0.9rem',
    color: 'var(--color-neutral-050)'
  }
}))

const StatusBadge = ({ isActive }) => {
  const classes = useStyles()

  return (
    <span className={classes.statusBadge}>{isActive ? 'Active' : 'Inactive'}</span>
  )
}

StatusBadge.propTypes = {
  isActive: PropTypes.bool.isRequired
}

export default StatusBadge
